import { gql } from '@apollo/client';

export const GET_KPIS_QUERY = gql`
  query getKPIsQuery($questionnaire_id: String!, $id: String) {
    kpis(questionnaire_id: $questionnaire_id, id: $id) {
      id
      deleted
      name
      created
      description
      order
      modified
      kpi_group {
        id
        name
      }
    }
  }
`;
